import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { buildUniqueClassName, buildUniqueIdName } from '~/helpers/seo-helpers';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cercle-multicolor-vide.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/checkbox-unchecked.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/checkbox-checked.svg';
var MULTICOLOR_FACET_KEYS = ['n293bc353ebac183d8fae449017e1492f9cd9046', 'Multicolore'];
export default {
  name: 'CategoryFacetItem',
  props: {
    circle: {
      type: Boolean,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    },
    facet: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      buildUniqueClassName,
      buildUniqueIdName,
      colors: {
        default: '',
        gray: '#b5bdc4',
        kraft: '#c4a181',
        dark: '#3c3c3b',
        white: '#ffffff'
      }
    };
  },

  computed: {
    icon() {
      if (this.isMultiColor) return 'cercle-multicolor-vide';
      var icons = this.circle ? ['', ''] : ['checkbox-checked', 'checkbox-unchecked'];
      return this.selected ? icons[0] : icons[1];
    },

    size() {
      return '16';
    },

    color() {
      return this.circle ? this.colors.kraft : this.colors.default;
    },

    colorStyle() {
      return {
        background: this.isMultiColor ? '#ffffff' : "#".concat(this.facet.hex_code),
        border: this.isWhite ? '1px solid #d7d7d7' : ''
      };
    },

    selectedColorStyle() {
      var tagColor = this.isWhite || this.isMultiColor ? '#9b9b9b' : "#".concat(this.facet.hex_code);
      return {
        '--tag-color': tagColor
      };
    },

    iconColorStyle() {
      return this.selected ? _objectSpread(_objectSpread({}, this.colorStyle), this.selectedColorStyle) : this.colorStyle;
    },

    isWhite() {
      return this.facet.hex_code === 'ffffff' || this.facet.key === 'Blanc';
    },

    isMultiColor() {
      return MULTICOLOR_FACET_KEYS.includes(this.facet.key);
    }

  }
};